module.exports = "/_next/static/chunks/images/logo-38d596cf89b09e1b33c040408c9b9a9d.png";